module.exports = __webpack_public_path__ + "static/media/shopify-text-logo.1be69ce6.png";